import {useEffect} from "react";
import axios from "axios";

export const get = async (url) => {
    return await axios(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${url}`,
        {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    );
};
export const post = async (url, body) => {
    return await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}${url}`,
        body,
        {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        });
};
